Browser = require '@trello/browser'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
stickerSize = require 'app/scripts/data/sticker-size'
stickerClip = require 'app/scripts/lib/util/sticker-clip'
t = require('app/scripts/views/internal/teacup-with-helpers')('sticker_on_card')
$ = require 'jquery'
Promise = require 'bluebird'
{ track } = require '@trello/analytics'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

HOVER_WAIT_MS = 350
REMOVE_WAIT_MS = 200
OVERLAP_PX = 8

USE_FANCY_PEEL = Browser.supportsFancyPeel()

template = t.renderable ({ url, rotate, image, showEditControls, showRemoveUI }) ->
  if showRemoveUI
    t.div '.sticker-removing', ->
      t.div '.sticker-removing-highlight',
        { style: "transform: rotate(#{ rotate }deg)" }
      if USE_FANCY_PEEL
        t.img '.sticker-remove-image.sticker-removing-residue',
          { src: require('resources/images/stickers/residue.png'), style: "--sticker-rotation: #{ rotate }deg; mask-image: #{ t.urlify(url) }; -webkit-mask-image: #{ t.urlify(url) };" }
        t.img '.sticker-remove-image.sticker-removing-shadow',
          { src: url, style: "--sticker-rotation: #{ rotate }deg" }
        t.img '.sticker-remove-image.sticker-removing-fixed',
          { src: url, style: "--sticker-rotation: #{ rotate }deg;" }
        t.img '.sticker-remove-image.sticker-removing-peel',
          { src: url, style: "--sticker-rotation: #{ rotate }deg" }
      else
        t.img '.sticker-remove-image.sticker-removing-fixed',
          { src: url, style: "transform: rotate(#{ rotate }deg)" }

    t.span '.sticker-control-btn.remove-btn.js-remove-sticker', { style: 'display: none' }, ->
      t.format 'remove'
  else
    t.img '.sticker-image', { src: url, style: '-webkit-transform: rotate(' + rotate + 'deg);transform: rotate(' + rotate + 'deg);', alt: image }
    if showEditControls
      t.div '.sticker-controls', ->
        t.span '.sticker-control-btn.rotate-btn.js-rotate-sticker', ->
          t.format 'rotate'
        t.span '.sticker-control-btn.move-btn.js-move-sticker', ->
          t.format 'move'
        t.span '.sticker-control-btn.remove-btn.js-remove-sticker', ->
          t.format 'remove'

measure = (el, options = {}) ->
  rect = el.getBoundingClientRect()

  left = rect.left
  top = rect.top
  right = if options.fixedWidth then left + options.fixedWidth() else rect.right
  bottom = if options.fixedHeight then top + options.fixedHeight() else rect.bottom

  return {
    left,
    top,
    bottom,
    right,
    width: right - left
    height: bottom - top
    x: left + (right - left) / 2
    y: top + (bottom - top) / 2
  }

# Find the best position for a control so that it
# - Is near the item being operated on (rect)
# - Is fully contained in a container (containerRect)
# - Is far from where the cursor is currently headed
getOptimalRemovePosition = ({ rect, containerRect, controlRect, currentX, currentY, deltaX, deltaY, interval }) ->
  angle = Util.getPositiveDegrees(-deltaY, deltaX)

  # We want to avoid some placements if they look like they're in the direction
  # the mouse is headed
  near = (avoidAngle) ->
    avoidAngle - 45 < angle < avoidAngle + 45

  yTop = -controlRect.height + OVERLAP_PX
  yMiddle = (rect.height - controlRect.height) / 2
  yBottom = rect.height - OVERLAP_PX

  xLeft = -controlRect.width + OVERLAP_PX
  xMiddle = (rect.width - controlRect.width) / 2
  xRight = (rect.width) - OVERLAP_PX

  potentialPositions = [
    # South
    {
      left: xMiddle
      top: yBottom
      avoid: near(270)
    },
    # North
    {
      left: xMiddle
      top: yTop
      avoid: near(90)
    },
    # East
    {
      left: xRight,
      top: yMiddle
      avoid: near(0) || near(360)
    },
    # West
    {
      left: xLeft,
      top: yMiddle
      avoid: near(180)
    },
    # Southwest
    {
      left: xLeft,
      top: yBottom,
      avoid: near(225)
    },
    # Southeast
    {
      left: xRight,
      top: yBottom,
      avoid: near(315)
    },
    # Northwest
    {
      left: xLeft,
      top: yTop,
      avoid: near(135)
    },
    # Northeast
    {
      left: xRight,
      top: yTop,
      avoid: near(45)
    },
  ]

  positionsWithVisibleArea = potentialPositions.map (pos) =>
    left = pos.left + (rect.left - containerRect.left)
    top = pos.top + (rect.top - containerRect.top)
    right = left + controlRect.width
    bottom = top + controlRect.height

    area =
      (Math.min(right, containerRect.width) - Math.max(0, left)) *
      (Math.min(bottom, containerRect.height) - Math.max(0, top))

    Object.assign({}, pos, { visibleArea: area })
  .sort((a, b) => b.visibleArea - a.visibleArea)

  (
    positionsWithVisibleArea.filter((pos) => !pos.avoid)[0] ||
    positionsWithVisibleArea.filter((pos) => pos.avoid)[0] ||
    positionsWithVisibleArea[0]
  )

removeRect = null

module.exports = class StickerView extends View
  className: 'sticker'

  initialize: ->
    super

    @listenTo @model, 'change', @render

  showEditControls: ->
    false

  events: ->
    if !@options.canRemove
      return {}

    return {
      'mouseenter': (e) ->
        if !@showRemoveUI
          @showRemoveUI = true
          @render()

      'mouseleave': 'mouseLeave'
      'mousemove': 'mouseMove'
      'mousedown': (e) ->
        if !@$(e.target).closest('.js-remove-sticker').length
          @removeRemove()
      'left-sticker': 'removeRemove'
      'mousemove .js-remove-sticker': (e) ->
        # Don't let the outer mouseMove handler get this; it'll
        # cancel a click on the remove button if the cursor moves
        # a little while the mouse is down
        Util.stop(e)

      'mouseenter .js-remove-sticker': (e) ->
        @$el.addClass('peeling')

      'mouseleave .js-remove-sticker': (e) ->
        @$el.removeClass('peeling')

      'click .js-remove-sticker': (e) ->
        Util.stop(e)
        @removeSticker()
    }

  render: ->
    data = @model.toJSON()
    data.url =
      Util.smallestPreviewBiggerThan(data.imageScaled, stickerSize)?.url ?
      data.imageUrl
    data.showEditControls = @showEditControls()
    data.showRemoveUI = @showRemoveUI

    @$el
    .html(template(data))
    .css({
      left: "#{ stickerClip(data.left) }%"
      top:  "#{ stickerClip(data.top) }%"
    })

    @


  mouseMove: (e) ->
    if e.buttons
      @removeRemove()
    else if @showingRemove
      @clearTimeouts()
    else if @hoverTimeout
      @currentX = e.offsetX
      @currentY = e.offsetY
    else
      @$el.siblings().trigger('left-sticker')

      @currentX = @startX = e.offsetX
      @currentY = @startY = e.offsetY

      @hoverTimeout = @setTimeout =>
        @showRemove()
      , HOVER_WAIT_MS

  showRemove: ->
    if @showingRemove
      return
    @showingRemove = true

    deltaX = @currentX - @startX
    deltaY = @currentY - @startY

    @$el.addClass('hover')

    $removeSticker = @$('.js-remove-sticker')

    Promise.try =>
      # HACK: Get the dimensions of the "remove sticker" button
      if removeRect
        return removeRect

      $removeSticker.css({ display: 'inline-block' })
      new Promise (resolve) =>
        @requestAnimationFrame =>
          removeRect = measure($removeSticker.get(0))
          $removeSticker.css({ display: 'none' })
          resolve(removeRect)
    .then (removeRect) =>
      { left, top } = getOptimalRemovePosition({
        rect: measure(@el)
        containerRect:
          measure(@$el.closest('.js-stickers-area').get(0), {
            fixedWidth: @options.fixedWidth,
            fixedHeight: @options.fixedHeight
          })

        controlRect: removeRect,
        currentX: @currentX,
        currentY: @currentY,
        deltaX: deltaX,
        deltaY: deltaY,
        interval: HOVER_WAIT_MS
      })

      $removeSticker.css({
        display: 'inline-block'
        top,
        left
      })
    .done()

  removeRemove: (e) ->
    if !@showingRemove
      return
    @showingRemove = false

    @clearTimeouts()

    @$('.js-remove-sticker').css({ display: 'none' })
    @$el.removeClass('hover peeling')

  mouseLeave: (e) ->
    @clearTimeouts()

    @removeTimeout = @setTimeout =>
      @removeRemove()
    , REMOVE_WAIT_MS

  clearTimeouts: ->
    clearTimeout @hoverTimeout
    @hoverTimeout = null
    clearTimeout @removeTimeout
    @removeTimeout = null

  removeSticker: ->
    track("Card", "Sticker", "Remove via Hover")

    if (featureFlagClient.get('dataeng.gasv3-event-tracking', false))
      Analytics.sendTrackEvent({
        action: "removed",
        actionSubject: "sticker",
        source: "stickerHoverView"
      })

    @clearTimeouts()
    @$el.remove()
    @model.destroy()
